import { UNITS } from './constants'

const deg2rad = deg => deg * (Math.PI/180)

export default {
  getDateObject(ts) {
    if (!ts) return null
    let number = ts
    if (typeof number === 'string') {
      number = Number(ts)
      if (number === 'NaN') return null
    }
    return new Date(number)
  },

  getDate(date) {
    const mm = (date.getMonth()+1).toString()
    const dd = date.getDate().toString()
    return date.getFullYear() + '-'
      + (mm.length < 2 ? '0'+mm : mm) + '-'
      + (dd.length < 2 ? '0'+dd : dd)
  },

  getTime(date) {
    const hh = date.getHours().toString()
    const mm = date.getMinutes().toString()
    const ss = date.getSeconds().toString()
    return (hh.length < 2 ? '0'+hh : hh) + ':'
      + (mm.length < 2 ? '0'+mm : mm) + ':'
      + (ss.length < 2 ? '0'+ss : ss)
  },

  formatDate(ts) {
    const date = this.getDateObject(ts)
    if (date === null) return ''
    return this.getDate(date)
  },

  formatTime(ts) {
    const date = this.getDateObject(ts)
    if (date === null) return ''
    return this.getTime(date)
  },

  formatDateTime(ts) {
    const date = this.getDateObject(ts)
    if (date === null) return ''
    return this.getDate(date)+' '+this.getTime(date)
  },

  commas(n, f=0) {
    if (typeof n !== 'number') n = Number(n)
    n = n.toFixed(f)
    const parts = n.toString().split(".")
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return parts.join(".")
  },

  kilo(n, i=0) {
    if (n < 1024) return n+UNITS[i]

    i++
    n = Math.floor(n / 1024)
    return this.kilo(n, i)
  },

  ellapsed(ms) {
    const day_ms = 1000 * 60 * 60 * 24
    const hour_ms = 1000 * 60 * 60
    const minute_ms = 1000 * 60

    const dd = Math.round(ms / day_ms)
    if (dd > 0) return this.commas(dd) + ' days ago'

    const hours = ms % day_ms
    const hh = Math.round(hours / hour_ms)
    if (hh > 0) return hh + ' hours ago'

    const minutes = hours % hour_ms
    const mm = Math.round(minutes / minute_ms)
    if (mm > 0) return mm + ' minutes ago'

    return (ms / 1000)+' seconds ago'
  },

  transpose(a) {
    return a[0].map( (_, c) => a.map( r => r[c] ) )
  },

  isNetworkAddress(a) {
    const el = a.split('.')
    if (el.length !== 4) return false
    return el.reduce((r, n) => isNaN(n) ? r.push(n) : r, []).length === 0
  },

  utfByteLength(s) {
    if (typeof s !== 'string') throw new Error('Input must be string')
    return Buffer.byteLength(s, 'utf8')
  },

  json(o) {
    return JSON.stringify(o, (k, v) => {
      if (v !== null) return v
    })
  },

  filter(obj, filters) {
    let results = {}
    for (let key in obj) {
      if (filters[key]) continue
      results[key] = obj[key]
    }
    return results
  },

  storageKeys() {
    const keys = []
    for (let i = 0, len = localStorage.length; i < len; i++) {
      keys.push(localStorage.key(i))
    }
    return keys
  },

  datatoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1])    // convert base64 to raw binary data held in a string
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]    // separate out the mime component

    const ab = new ArrayBuffer(byteString.length) // write the bytes of the string to an ArrayBuffer
    const ia = new Uint8Array(ab)   // create a view into the buffer
    for (let i = 0; i < byteString.length; i++) {   // set the bytes of the buffer to the correct values
        ia[i] = byteString.charCodeAt(i)
    }

    const blob = new Blob([ab], {type: mimeString})   // write the ArrayBuffer to a blob, and you're done
    return blob
  },

  distance(lat1, lon1, lat2, lon2) {
    const R = 6371 // Radius of the earth in km
    const dLat = deg2rad(lat2-lat1)
    const dLon = deg2rad(lon2-lon1)
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon/2) * Math.sin(dLon/2)

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c // Distance in km
  },

  isfunction(o) {
    return o && {}.toString.call(o) === '[object Function]'
  },

  isarray(o) {
    return Array.isArray(o)
  },

  keys(object) {
    const keys = []
    const traverse = obj => {
      for (let prop in obj) {
        if (object.hasOwnProperty(prop)) {
          keys.push(prop)
          const o = obj[prop]
          if (o && typeof o === 'object' && !Array.isArray(o) && {}.toString.call(o) !== '[object Function]') {
            traverse(o)
          }
        }
      }
    }
    traverse(object)
    return keys
  },

  isFullScreen() {
    return document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement
  },


}



// WEBPACK FOOTER //
// ./src/lib/utils.js